import React, { Component } from "react";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import { breadcrumbs } from "../../../../actions/appActions";
import loginInfo from "../../components/LoginInfo";
import AuditHistoryView from "../../components/AuditHistoryView";
import UserHistoryDetailGrid from "../../components/grids/UserHistoryDetailGrid";
import { SPRAVCE_HISTORY_ENTITIES } from "../../components/audit/entityLabels";
import Button from "../../../../components/form/Button";
import { styles } from "../../index";

class UserHistoryPage extends Component {
  isAdministratorsUrl() {
    const path = (this.props.location && this.props.location.pathname) || "";
    return path.includes("/administratori/");
  }

  componentWillMount() {
    const { auth } = this.props;
    const isAdmins = this.isAdministratorsUrl();
    const listLabel = isAdmins ? "Administrátoři" : "Správci";
    const listPath = `${auth.startUrl}/${isAdmins ? "administratori" : "spravci"}`;
    this.props.breadcrumbs([
      { label: listLabel, path: listPath },
      { label: "Historie aktivit" },
    ]);
  }

  render() {
    const { auth, params } = this.props;
    const isAdmins = this.isAdministratorsUrl();
    const segment = isAdmins ? "administratori" : "spravci";
    return (
      <div>
        <AuditHistoryView
          auth={auth}
          grid={UserHistoryDetailGrid}
          gridName={isAdmins ? "adminUserHistoryGridV2" : "internalUserHistoryGridV2"}
          url={`/spravce/api/${segment}/${params.id}/historie`}
          showOwner
          allowedEntityTypes={SPRAVCE_HISTORY_ENTITIES}
        />
        <div style={{ marginTop: 12 }}>
          <Button
            type="button"
            style={styles.buttons}
            label="Zpět"
            onClick={() => this.props.goBack()}
          />
        </div>
      </div>
    );
  }
}

export default connect(null, { breadcrumbs, goBack })(loginInfo(UserHistoryPage));
